// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"688":"43e2c47e","884":"78d27913"}[chunkId] + ".chunk.css";
};